import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FieldHint} from './field-hint';

@Component({
    selector: 'mydocma-field-hint',
    templateUrl: './hint.component.html',
    styleUrls: ['./hint.component.scss']
})
export class HintComponent implements OnInit, OnChanges {
    @Input() hint: FieldHint;

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

}
